var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-truncate"},_vm._l((_vm.meals),function(meal,index){return _c('span',{key:meal.id + '_' + index,attrs:{"data-toggle":"tooltip","data-placement":"top","title":_vm.tooltipText}},[_vm._v(_vm._s(meal.name)+", ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }